import { useQuery } from '@tanstack/react-query';
import { invokeEdgeFunction } from '@/utils/invokeEdgeFunction';

export interface AuthUser {
  id: string;
  email?: string;
}

export function useAuthUsers() {
  return useQuery<{ users: AuthUser[] }>({
    queryKey: ['auth-users'],
    queryFn: async () => {
      return await invokeEdgeFunction<{ users: AuthUser[] }>('list-users');
    },
  });
}
